import Cookie from "js-cookie";

export const storage = getProxy(window.localStorage);
export const session = getProxy(window.sessionStorage);

function getProxy(webStorage: Storage): Record<string, string> {
  const hasStorage = hasStorageSupport(webStorage);

  return new Proxy(
    {},
    {
      set(_obj, prop, value) {
        if (hasStorage) {
          webStorage.setItem(prop.toString(), String(value));
        } else {
          Cookie.set(prop.toString(), value);
        }

        return true;
      },
      get(_obj, prop) {
        return hasStorage ? webStorage.getItem(prop.toString()) : Cookie.get(prop.toString());
      },
      has(obj, prop) {
        return typeof Reflect.get(obj, prop) === "string";
      },
      deleteProperty(_obj, prop) {
        if (hasStorage) {
          webStorage.removeItem(prop.toString());
        } else {
          Cookie.set(prop.toString(), "", { expires: -1 });
        }

        return true;
      },
    },
  );
}

/**
 * Whether the current browser supports local storage as a way of storing data
 */
function hasStorageSupport(webStorage: Storage): boolean {
  try {
    webStorage.setItem("__storage__", "foo");
    webStorage.removeItem("__storage__");

    return true;
  } catch {
    return false;
  }
}
